export enum CatchStockType {
  CATCH = 'catch',
  STOP_LOSS = 'stoploss',
}

export enum CatchType {
  STAR = 'star',
  NULLIM = 'nullim',
  TURN = 'turn',
  BEST = 'best',
}
